export const APPRAISALS_REQUEST = 'APPRAISALS_REQUEST';
export const APPRAISALS_SUCCESS = 'APPRAISALS_SUCCESS';
export const APPRAISALS_GET_SUCCESS = 'APPRAISALS_GET_SUCCESS';
export const APPRAISALS_VALIDATION_ERROR = 'APPRAISALS_VALIDATION_ERROR';
export const APPRAISALS_REDIRECT_TO_LIST = 'APPRAISALS_REDIRECT_TO_LIST';
export const APPRAISALS_RESET_SETUP_FLOW = 'APPRAISALS_RESET_SETUP_FLOW';
export const APPRAISALS_CLEAR_LIST_REDIRECT = 'APPRAISALS_CLEAR_LIST_REDIRECT';
export const HIDE_APPRAISALS_FEILD_VALIDATION_ERROR = "HIDE_APPRAISALS_FEILD_VALIDATION_ERROR";
export const APPRASIAL_SHOW_CATEGORY_SETUP_WINDOW = 'APPRASIAL_SHOW_CATEGORY_SETUP_WINDOW';

export const APPRAISAL_PROGRESS_REQUEST = 'APPRAISAL_PROGRESS_REQUEST';
export const APPRAISAL_PROGRESS_SUCCESS = 'APPRAISAL_PROGRESS_SUCCESS';
export const APPRAISAL_PROGRESS_GET_SUCCESS = 'APPRAISAL_PROGRESS_GET_SUCCESS';
export const APPRAISAL_PROGRESS_VALIDATION_ERROR = 'APPRAISAL_PROGRESS_VALIDATION_ERROR';
export const APPRAISAL_PROGRESS_RESET_FLAGS = 'APPRAISAL_PROGRESS_RESET_FLAGS';
export const APPRAISAL_PROGRESS_RESET_RECORD = 'APPRAISAL_PROGRESS_RESET_RECORD';
export const APPRAISAL_PROGRESS_SUBMIT_SUCCESS = 'APPRAISAL_PROGRESS_SUBMIT_SUCCESS';
export const APPRAISAL_PROGRESS_APPROVE_SUCCESS = 'APPRAISAL_PROGRESS_APPROVE_SUCCESS';
export const APPRAISAL_PROGRESS_REJECT_SUCCESS = 'APPRAISAL_PROGRESS_REJECT_SUCCESS';
export const APPRAISAL_ACTIVITY_LOGS_REQUEST = 'APPRAISAL_ACTIVITY_LOGS_REQUEST';
export const APPRAISAL_ACTIVITY_LOGS_SUCCESS = 'APPRAISAL_ACTIVITY_LOGS_SUCCESS';
export const APPRAISAL_ACTIVITY_LOGS_ERROR = 'APPRAISAL_ACTIVITY_LOGS_ERROR';

export const MY_PAFS_REQUEST = 'MY_PAFS_REQUEST';
export const MY_PAFS_SUCCESS = 'MY_PAFS_SUCCESS';
export const MY_PAFS_GET_SUCCESS = 'MY_PAFS_GET_SUCCESS';
export const MY_PAFS_SIGN_SUCCESS = 'MY_PAFS_SIGN_SUCCESS';
export const MY_PAFS_VALIDATION_ERROR = 'MY_PAFS_VALIDATION_ERROR';
export const MY_PAFS_RESET_RECORD = 'MY_PAFS_RESET_RECORD';
export const MY_PAFS_DELETE_SUCCESS = 'MY_PAFS_DELETE_SUCCESS';

export const SECTIONS_REQUEST = 'SECTIONS_REQUEST';
export const SECTIONS_SUCCESS = 'SECTIONS_SUCCESS';
export const SECTIONS_GET_SUCCESS = 'SECTIONS_GET_SUCCESS';
export const SECTIONS_VALIDATION_ERROR = 'SECTIONS_VALIDATION_ERROR';
export const SECTIONS_REDIRECT = 'SECTIONS_REDIRECT';
export const HIDE_SECTIONS_FIELD_VALIDATION_ERROR = 'HIDE_SECTIONS_FIELD_VALIDATION_ERROR';

export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
